import axios from 'axios';

export class CatalogDateService {
    getMaxValueDate() {
        return axios.get('/appapv/getMaxValueDate.action', {
            headers: {
                'Content-Type': 'application/json',
            }
        }).then(res => res.data.payload);
    }

    getMaturityDate(maturity, valueDate) {
        return axios.get('/appapv/getMaturityDate.action', {
            headers: {
                'Content-Type': 'application/json',
            },
            params: {
                plazo: maturity,
                fecValor: valueDate
            }
        }).then(res => res.data.payload);
    }
}